var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fiesta"},[_c('ImageGallery',{staticClass:"image-gallery",attrs:{"image-list":_vm.novias}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }